
window._ = require('lodash');


/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
window.$ = window.jQuery = require('jquery');

window.Popper = require('popper.js').default;

//Tipps.js for popovers
//window.tippy = require('./scripts/tippy.all.min.js');
	
} catch (e) {}


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.querySelector('meta[name="csrf-token"]');
 	
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

//Snackbars for material bootstrap
//require('./scripts/snackbar-min');

// Material Design JS
require('./scripts/bootstrap-material-design');

// React Navigation JS
require('./skyeTopNavigation.js');

// React CookieConsent JS
require('./cookieConsentDialog.js');

//Load Skye Interface Module
require('./scripts/SkyeBasicInterface/SkyeBasicInterfaceModuleImports.js');

// Applciation Javascript Helpers
require('./scripts/skye-js-utils');

// Application Jquery Helpers
require('./scripts/skye-jq-utils');

// Shopping Cart Script
require('./scripts/cart'); 

// Adding BusinessPage Hover Box Script Solo
require('./scripts/SkyeHoverBox.js');

// Loading Chart.js for charts creation on Work Confidence Page
require('./scripts/chart.bundle.min');
